'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwButton = require('../cwbutton/CwButton');

var _CwButton2 = _interopRequireDefault(_CwButton);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _DateUtils = require('../../utils/DateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a button who's job is to set the current day as the selected dat. It does this by generating a new date
 * object which defaults to the current date.
 */
var TodayPicker = function TodayPicker(props) {

  var handleClick = function handleClick() {
    var dateObject = (0, _moment2.default)();
    var date = props.isDateTime ? (0, _DateUtils.getDate)(dateObject.date(), dateObject.month(), dateObject.year()) : (0, _DateUtils.getUtcDate)(dateObject.date(), dateObject.month(), dateObject.year());
    props.onChange(date);
  };

  return _react2.default.createElement(_CwButton2.default, { isStandard: true, onClick: handleClick, value: props.value });
};

TodayPicker.propTypes = {
  /**
   * The localized string for the word today
   */
  value: _propTypes2.default.string,
  /**
   * A function that should update the value in the text field when one has been selected from the Calendar.
   */
  onChange: _propTypes2.default.func
};

exports.default = TodayPicker;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/TodayPicker.js
// module id = 830
// module chunks = 10